<template>
  <el-card class="box-card main-card">

    <el-row type="flex" justify="space-between">
      <el-form
        :inline="true"
        :model="searchForm"
        class="demo-form-inline"
        label-width="85px"
      >
        <el-form-item label="状态：">
          <el-select
            v-model="searchForm.status"
            placeholder="请选择状态"
            size="small"
            clearable
          >
            <template v-for="item in statusList">
              <el-option
                :label="item.label"
                :value="item.value"
                :key="item.value"
              ></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="名称：">
          <el-input
          v-model="searchForm.itemName"
            size="small"
            placeholder="请输入名称"
            style="width: 199px"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label=" ">
          <el-button size="small" class="pxy-primary" @click="searchFn">查 询</el-button>
        </el-form-item>
      </el-form>
      <el-button class="pvt-color" type="text" @click="openAddDialog('add')">去添加</el-button>
    </el-row>
    <el-table ref="refTable" :data="tableData" style="width: 100%">
      <el-table-column type="index"></el-table-column>
      <template v-for="item in columns">
        <el-table-column :prop="item.key" :label="item.label" :key="item.id" :min-width="item.width">
        </el-table-column>
      </template>
      <el-table-column label="操作" fixed="right" min-width="150" v-loading="true">
        <template slot-scope="scope">
          <el-button class="pvt-color" type="text" @click="openAddDialog('update',scope.row)">更改</el-button>
          <el-button class="pvt-color" type="text" :disabled="scope.row.status===0" @click="openBindingDialog(scope.row)">绑定客户</el-button>
          <el-button class="pvt-color" type="text" @click="statusChange(scope.row)">{{scope.row.status===0?'激活':'禁用'}}</el-button>
          <el-button type="text" class="del-btn-text" @click="delFn(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
     <PageComponent ref="pageInfo"></PageComponent>
    <el-dialog
      center
      :title="handleType==='add'?'添加':'更改'"
      :visible.sync="addDialogVisible"
      width="30%">
      <div>
        <el-form :model="addForm" class="demo-form-inline" label-width="100px" :rules="rules" ref="addForm">
          <el-form-item label="名称：" prop="itemName">
            <el-input v-model="addForm.itemName" size="small" placeholder="请输入名称" style="width: 199px" clearable></el-input>
          </el-form-item>
          <el-form-item label="类型：">
            <el-radio-group v-model="addForm.type" :disabled="addForm.feeByPeriod == 0">
              <el-radio :label="'0'">存储</el-radio>
              <el-radio :label="'1'">并发</el-radio>
              <el-radio :label="'2'">其他</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否按周期：">
            <el-radio-group v-model="addForm.feeByPeriod" @change="feeByPeriodChange">
              <el-radio :label=1>是</el-radio>
              <el-radio :label=0>否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="周期：">
            <el-radio-group v-model="addForm.periodUnit" :disabled="addForm.feeByPeriod == 0">
              <el-radio :label="'D'">天</el-radio>
              <el-radio :label="'M'">月</el-radio>
              <el-radio :label="'Y'">年</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="价格：" prop="price">
            <el-input v-model="addForm.price" size="small" placeholder="请输入价格" style="width: 199px" clearable></el-input>
          </el-form-item>
          <el-form-item label="备注：">
            <el-input v-model="addForm.note" size="small" placeholder="请输入备注" style="width: 199px" clearable></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button v-if="handleType==='add'" type="primary" @click="saveAddFn" size="small">保 存</el-button>
        <el-button v-if="handleType==='update'" type="primary" @click="saveUpdateFn" size="small">保 存</el-button>
      </span>
    </el-dialog>
    <el-dialog
      center
      title="绑定客户"
      :visible.sync="userDialogVisible"
      width="600">
      <div>
      <el-row  v-if="showAllUserListFlag">
        <span>手机号：</span>
        <el-input v-model="mobileSearchVal" clearable style="width:195px;margin: 0 30px 20px 0;" placeholder="请输入手机号" size="small"></el-input>
        <el-input v-model="loginIdSearchVal" clearable style="width:195px;margin: 0 30px 20px 0;" placeholder="请输入客户登录ID" size="small"></el-input>
        <el-button size="small" type="primary" @click="getUserList">查询</el-button>
      </el-row>
        <el-button v-if="!showAllUserListFlag" type="text" @click="getUserList()" class="pvt-color" style="float: right;margin-top: -11px;margin-right: 20px">去绑定</el-button>
      <el-table ref="userTable" :data="userList" style="width: 100%">
        <el-table-column type="index"></el-table-column>
        <el-table-column prop="accountId" label="客户登录ID"></el-table-column>
        <el-table-column prop="mobile" label="客户手机号"></el-table-column>
        <el-table-column  v-if="!showAllUserListFlag" prop="mobile" label="扣费日期">
          <template slot-scope="scope">
            <span v-if="scope.row.feeByPeriod == '1'">

              <span v-if="scope.row.periodUnit == 'M'">
                每月的
                 {{scope.row.createDate | formatDateToDay}}
              </span>
               <span v-else-if="scope.row.periodUnit == 'D'">
                每
              </span>
                <span v-else>
                每年的
                 {{scope.row.createDate | formatDateToMonthDay}}
              </span>
              日，凌晨3点
            </span>
            <span v-else>
              {{scope.row.createDate | formatDate }}

            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right">
          <template slot-scope="scope">
            <el-button v-if="scope.row.withExtraProdFlag==='0'" type="text" @click="bindingFn(scope.row)">绑定</el-button>
            <el-button v-if="scope.row.withExtraProdFlag==='1'" type="text" @click="unBindingFn(scope.row)">解绑定</el-button>
            <el-button v-if="!showAllUserListFlag" type="text" @click="unBindingFn(scope.row)">解绑定</el-button>
            <el-button v-if="!showAllUserListFlag" type="text" @click="gotoAccountPayLog(scope.row)">查看收支明细</el-button>

          </template>
        </el-table-column>
      </el-table>
      <el-row type="flex" justify="center">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :page-size="userPagination.size"
          :current-page.sync="userPagination.page"
          layout="total, prev, pager, next"
          :total="userPagination.total">
        </el-pagination>
      </el-row>
    </div>
    </el-dialog>
  </el-card>
</template>
<script>
import PageComponent from "@/components/pageInfo/PageComponent";
import { Message } from "element-ui";
import { formatDateTime } from "@/utils/util.js"
const columns = [
  {
    key: "id",
    label: "id",
    width: '200'
  },
  {
    key: "itemName",
    label: "名称",
    width: '120'
  },
  {
    key: "feeByPeriodSelf",
    label: "是否按周期",
    width: '120'
  },
  {
    key: "periodUnitSelf",
    label: "周期",
    width: '120'
  },
  {
    key: "price",
    label: "价格",
    width: '120'
  },
  {
    key: "statusSelf",
    label: "状态",
    width: '120'
  },
];
const validDecimals = (rule, value, callback) => {
    if (value === '' || value === 0) {
      callback(new Error('请输入充值金额！'))
    } else if (!(/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/.test(Number(value)))) {
      callback(new Error('请输入正数！'))
    } else {
      callback()
    }
  }
export default {
  components: { PageComponent },
  data() {
    return {
      columns: columns,
      tableData: [],
      statusList: [
        // 状态字典项
        { value: 0, label: "无效" },
        { value: 1, label: "有效" },
      ],
      statusObj: {
        0: '无效',
        1: '有效',
      },
      periodObj: {
        D: '天',
        M: '月',
        Y: '年'
      },
      searchForm: {
        itemName: '',
        status: ''
      },
      rules: {
        itemName: [{required: true,message: '请输入名称',trigger: 'blur'}],
        price: [{required: true,message: '请输入价格',trigger: 'blur'},{validator: validDecimals, trigger: 'blur'}],
      },
      handleType: '',
      handleRow: {},
      addDialogVisible: false,
      addForm: {
        itemName: '',
        type: '',
        feeByPeriod: 1,
        periodUnit: 'Y',
        price: '',
        note: ''
      },
      userDialogVisible: false,
      mobileSearchVal: '',//查询客户的手机号
      loginIdSearchVal:'',
      userList: [],
      boundUserList: [],
      showAllUserListFlag : false,
      userPagination: {
        total: 0,
        size: 8,
        page: 1
      },
      extraProdPagination: {
        total: 0,
        size: 20,
        page: 1
      }
    };
  },
  created() {},
  mounted: function () {
     this.$refs.pageInfo.initPagenator(this.getList, 10);
    this.getList();
  },
  methods: {
    getList() {
      let params = {}
      if(this.searchForm.itemName) params.itemName = this.searchForm.itemName;
      if(this.searchForm.status!=='') params.status = this.searchForm.status;
        params.page = this.$refs.pageInfo.currentPage;
        params.pageSize = 10;
      this.getRequest("/pocExtraProdItem/list", params).then((resp) => {
        if (resp.status == 200) {
          if (resp.data.code == 1000) {
            if (resp.data.result) {
              this.tableData = resp.data.result.records.map((item) => {
                return Object.assign(item, {
                  statusSelf: this.statusObj[item.status],
                  periodUnitSelf: this.periodObj[item.periodUnit],
                  feeByPeriodSelf: item.feeByPeriod?'是':'否'
                });
              });
               this.$refs.pageInfo.outputPagenator(resp.data.result.total);
            }
          } else {
            Message.error(resp.data.message);
          }
        } else {
          console.error("error");
        }
      });
    },
    searchFn() {
        // var queryStr = JSON.parse(JSON.stringify(this.$route.query));
        // queryStr.page = 1;
        // this.$router.push({query: queryStr});
        this.getList();
    },
    // 打开添加弹窗
    openAddDialog(handleType,row) {
      this.handleType = handleType;
      if(row){
        this.handleRow = row;
        this.addForm = row;
      }
      this.addDialogVisible = true;
    },
    // 添加保存
    saveAddFn() {
      this.$refs.addForm.validate(valid => {
        if(valid) {
          let params = {
            itemName: this.addForm.itemName,
            type: this.addForm.type,
            feeByPeriod: this.addForm.feeByPeriod,
            periodUnit: this.addForm.periodUnit,
            price: this.addForm.price,
            note: this.addForm.note
          };
          this.postRequestJson("/pocExtraProdItem/add", params).then((resp) => {
              if (resp.status == 200) {
                if(resp.data.code == 1000){
                  this.$message.success('添加成功')
                  this.$refs.addForm.resetFields();
                  this.addDialogVisible = false;
                  this.getList();
                }else {
                  Message.error(resp.data.message)
                }
              }
            }
          );
        }
      })
    },
    // 更改-保存
    saveUpdateFn() {
      let params = this.addForm;
      this.updateFn(params);
    },
    // 激活、禁用
    statusChange(row) {
      let params = {
        id: row.id,
        status: ''
      }
      if(row.status===0) params.status = 1;
      if(row.status===1) params.status = 0;
      this.postRequestJson("/pocExtraProdItem/update", params).then((resp) => {
        if (resp.status == 200) {
          if(resp.data.code == 1000){
            this.$message.success(row.status===0?'激活成功':'禁用成功');
            this.getList();
          }else {
            Message.error(resp.data.message)
          }
        }
      });
    },
    updateFn(params) {
      this.$refs.addForm.validate(valid => {
        if(valid) {
          this.postRequestJson("/pocExtraProdItem/update", params).then((resp) => {
              if (resp.status == 200) {
                if(resp.data.code == 1000){
                  this.$message.success('更改成功')
                  this.$refs.addForm.resetFields();
                  this.handleRow = {};
                  this.addDialogVisible = false;
                  this.getList();
                }else {
                  Message.error(resp.data.message)
                }
              }
            }
          );
        }
      })
    },
    // 删除
    delFn(row) {
      let params = {
        id: row.id
      }
      var _this = this;
        _this.$confirm('是否删除当前扣费设置？', "提示", {
          confirmButtonText: "是",
          cancelButtonText: "取消",
          type: 'warning'
        }).then(() => {
          this.postRequestJson("/pocExtraProdItem/delete", params).then((resp) => {
            if (resp.status == 200) {
              if(resp.data.code == 1000){
                this.$message.success('删除成功')
                this.getList();
              }else {
                Message.error(resp.data.message)
              }
            }
          });
        }).catch(() => {
          _this.$message({
            type: 'info',
            message: '已取消'
          });
        });

    },
    // 打开绑定客户弹窗
    openBindingDialog(row) {
      this.handleRow = row;
      this.userDialogVisible = true;
      this.getBoundUserList();
    },
    // 获取已绑定的客户列表
    getBoundUserList() {
      this.showAllUserListFlag = false;
      let params = {
        extraProdItemId: this.handleRow.id,
        pageSize: this.userPagination.size,
        page: this.userPagination.page
      }
      this.getRequest("/pocExtraProdWithUser/list", params).then((resp) => {
        if (resp.status == 200) {
          let data = resp.data;
          if (data.code == 1000) {
            if (data.result) {
              if(data.result.records.length == 0){
                this.getUserList();
              }else {
                this.userList = data.result.records;
                this.userPagination.total = Number(data.result.total);
              }

            }
          } else {
            Message.error(resp.data.message);
          }
        } else {
          console.error("error");
        }
      });
    },
    // 获取客户列表
    getUserList() {
      this.showAllUserListFlag = true;
      let params = {
        extraProdItemId: this.handleRow.id,
        pageSize: this.userPagination.size,
        page: this.userPagination.page
      }
      if(this.mobileSearchVal) params.mobile = this.mobileSearchVal;
      if(this.loginIdSearchVal) params.accountId = this.loginIdSearchVal;
      this.getRequest("/uacUser/list", params).then((resp) => {
        if (resp.status == 200) {
          let data = resp.data;
          if (data.code == 1000) {
            if (data.result) {
             this.userList = data.result.records;
             this.userPagination.total = Number(data.result.total);
             }
          } else {
            Message.error(resp.data.message);
          }
        } else {
          console.error("error");
        }
      });
    },
    handleCurrentChange(val) {
      this.userPagination.page = val;
      this.getUserList();
    },
    // 绑定客户
    bindingFn(row) {
      this.$confirm("温馨提示：绑定之后立即扣费，请慎重绑定！", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: 'warning'
      }).then(() => {
        let params = {
          extraProdItemId: this.handleRow.id,
          userId: row.userId
        }
        this.postRequestJson("/pocExtraProdWithUser/add", params).then((resp) => {
          if (resp.status == 200) {
            if(resp.data.code == 1000){
              this.$message.success('绑定成功')
              this.getUserList();
            }else {
              Message.error(resp.data.message)
            }
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: "取消"
        });
      });

    },
    // 解绑定
    unBindingFn(row) {
      let params = {
        extraProdItemId: this.handleRow.id,
        userId: row.userId
      }
      this.postRequestJson("/pocExtraProdWithUser/delete", params).then((resp) => {
        if (resp.status == 200) {
          if(resp.data.code == 1000){
            this.$message.success('解绑定成功')
            this.getUserList();
          }else {
            Message.error(resp.data.message)
          }
        }
      });
    },
    feeByPeriodChange(val) {
      if(!val) this.addForm.periodUnit = '';
    },
    gotoAccountPayLog(val){
      this.$router.push({ // 查看收支明细
        path: '/account/accountLog',
        query: {
          userId: val.userId,
          userName: val.accountId
        }
      })
    }
  },
  beforeDestroy(){}
};
</script>
<style lang="scss" scoped>
.del-btn-text {
  color: #F56C6C;
}
</style>
